import styled from 'styled-components';
import { Button } from '../button';
import { getArrowPosition, getTooltipPosition } from './utils';
// arrow dafault shape
const triangleShape = `
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-color:${({ theme }) => theme.colors.grey24};
  border-radius: 3px;
  position: absolute;
  border: 12px solid ;
  border-top-color: transparent;
  border-right-color: #C3C2C8;
  border-bottom-color: transparent;
  border-left-color: transparent;
`;
export const PopContainer = styled.div `
  // estado inicial => oculto
  transition: all 0.3s ease-in-out;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};

  // estilos generales
  width: 300px;
  padding: 12px;
  z-index: 10;
  background-color: #ffffff;
  border: 1px solid ${({ theme }) => theme.colors.grey24};
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);

   @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    width:324px;    
  }

  // alineacion del contenido: texto, img, boton
  align-items: flex-start;
  justify-content: space-between;

  // ubicacion del popover common
  position: absolute;
  ${({ setArrowPos }) => getTooltipPosition(setArrowPos)};

  // tooltip arrow
    &:before {
      ${triangleShape}
      ${({ setArrowPos }) => getArrowPosition(setArrowPos)};
    }
  }
`;
export const PopoverArea = styled.div `
  width: ${({ fullwidth }) => (fullwidth ? '100%' : 'auto')};
  position: relative;
  display: inline-block;
`;
export const Image = styled.img `
  width: 60px;
`;
export const MainContent = styled.span `
  margin: 0px 5px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
export const CustomButton = styled(Button) `
  padding: 0px;
`;
